import React from 'react';

interface Rate {
  weekly: number;
  nightly: number;
}

interface RatesByType {
  cottages: {
    C1: Rate;
    C2: Rate;
    C3: Rate;
    P1: Rate;
    P2: Rate;
    P3: Rate;
  };
  apartments: {
    A1: Rate;
    A2: Rate;
    A3: Rate;
  };
  dorm: {
    D1: Rate;
    D2: Rate;
  };
  campsite: {
    T1: Rate;
    T2: Rate;
  };
}

interface PriceCode {
  code: string;
  description: string;
  type: keyof RatesByType;
  serviceLevel: 'full' | 'partial' | 'none' | 'single' | 'double';
}

export function getRateForPriceCode(
  priceCode: string,
  rates: RatesByType,
  priceCodes: PriceCode[]
): Rate | null {
  console.log('Getting rate for price code:', priceCode);
  console.log('Available rates:', rates);
  console.log('Price codes:', priceCodes);
  
  // Find the price code info to get the type (e.g., cottages, dorm, etc.)
  const priceCodeInfo = priceCodes.find(pc => pc.code === priceCode);
  console.log('Found price code info:', priceCodeInfo);
  
  if (!priceCodeInfo) return null;

  const { type } = priceCodeInfo;
  console.log('Accommodation type:', type);
  
  const accommodationRates = rates[type];
  console.log('Accommodation rates:', accommodationRates);
  
  if (!accommodationRates) return null;

  // Get the rate for this specific price code
  const rate = accommodationRates[priceCode as keyof typeof accommodationRates];
  console.log('Found rate:', rate);
  
  return rate || null;
}

interface RateDisplayProps {
  priceCode: string;
  rates: RatesByType;
  priceCodes: PriceCode[];
}

export const RateDisplay: React.FC<RateDisplayProps> = ({ priceCode, rates, priceCodes }) => {
  const rateInfo = getRateForPriceCode(priceCode, rates, priceCodes);
  const priceCodeInfo = priceCodes.find(pc => pc.code === priceCode);

  if (!rateInfo || !priceCodeInfo) return null;

  return (
    <div>
      <p>Weekly Rate: {new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(rateInfo.weekly)}</p>
      <p>Nightly Rate: {new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(rateInfo.nightly)}</p>
    </div>
  );
};

export type { RatesByType, PriceCode, Rate }; 